/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class StyledSelect extends React.Component {
	componentDidMount() {

		if (this.props.onMount !== null) {
			this.props.onMount();
		}

	}

	render() {
		let selectClass = classnames('styled-select', this.props.selectClass),
			value = (this.props.value === null || this.props.value === undefined) ? '' : this.props.value;

		if (typeof this.props.value === "function") {
			value = this.props.value();
		}

		if (this.props.refName) {
			return (
				<div className={selectClass}>
					<select disabled={this.props.controlState} ref={this.props.refName} data-field={this.props.linkedField} value={value} onChange={this.props.onChange} aria-label={this.props.ariaLabel}>
					{this.props.options.map(function(opt, i){
						if (opt.value !== undefined && opt.label !== undefined) {
							return (<option key={i} value={opt.value}>{opt.label}</option>);
						} else {
							return (<option key={i} value={opt}>{opt}</option>);
						}
					}, this)}
					</select>
				</div>
			);
		} else {
			return (
				<div className={selectClass}>
					<select disabled={this.props.controlState} data-field={this.props.linkedField} value={value} onChange={this.props.onChange} aria-label={this.props.ariaLabel}>
					{this.props.options.map(function(opt, i){
						if (opt.value !== undefined && opt.label !== undefined) {
							return (<option key={i} value={opt.value}>{opt.label}</option>);
						} else {
							return (<option key={i} value={opt}>{opt}</option>);
						}
					}, this)}
					</select>
				</div>
			);
		}

	}

};

StyledSelect.displayName = "StyledSelect";

StyledSelect.propTypes = {
	options: PropTypes.array,
	linkedField: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.func
	]),
	selectClass: PropTypes.string,
	ariaLabel: PropTypes.string,
	onChange: PropTypes.func,
	controlState: PropTypes.string,
	onMount: PropTypes.func,
	refName: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.func
	])
};

StyledSelect.defaultProps = {
	options: [],
	linkedField: '',
	value: null,
	selectClass: '',
	onChange: null,
	controlState: '',
	onMount: null,
	refName: ''
};

export default StyledSelect;
